import { takeEvery, all, put, call } from 'redux-saga/effects'
import { actions } from './ContactFormReducer'
import config from 'site.config'

const {
  configuration: { envVars }
} = config

export function* postContactForm(services, { payload }) {
  yield put(actions.submitFeedbackForm())
  const cookieService = services('CookieService')
  const authToken = JSON.parse(cookieService.get('authToken'))
  try {
    const apiService = services('APIService')
    const baseUrl =
      envVars?.REACT_APP_PHNX_API ?? process.env.REACT_APP_PHNX_API
    const subUrl = payload.isAuth ? '/v2/user/feedback' : '/v2/user/contact-us'
    const url = baseUrl + subUrl
    const additionalHeader = {
      Authorization: `Bearer ${authToken.access}`
    }
    const result = yield call(
      [apiService, 'postWithHeaders'],
      url,
      {
        message: payload.message,
        brandCode: payload.brandCode,
        fields: {
          email: payload.fields.email,
          firstName: payload.fields.firstName,
          lastName: ' '
        },
        brandType: payload.isAuth ? 'feedback' : 'contactUs',
        idhBrandId: payload.idhBrandId,
        piwikSiteId: payload.piwikSiteId,
        device: payload.device,
        reCaptcha: payload.reCaptcha
      },
      additionalHeader
    )
    yield put(actions.submitContactFormSuccess(result))
  } catch (e) {
    console.error('postContactForm:', e.message)
    yield put(actions.submitContactFormFail())
  }
}

export default function* watchContactForm(services) {
  yield all([takeEvery(actions.submitContactForm, postContactForm, services)])
}
